import Logger from './logger';

const log = new Logger();

/**
 * getFormattedUrl:
 * Returns a URL given a set of params
 *
 * @param params
 * @returns {*}
 */
export default (params = {}) => {
  let url = process.env.TRIALS.V1_REDIRECT_URL;

  if (params.length === 0) return false;

  // Adds custom demo user information to login url
  url = url.replace(/\{0\}/g, params.domain);
  url = url.replace(/\{1\}/g, params.sessionToken);
  url = url.replace(/\{2\}/g, params.ip);

  log.debug({
    category: 'helpers',
    message: 'getFormattedUrl',
    data: { url }
  });

  return url;
};
